<template>
  <CheckoutAddressInfoItem>
    <template #left>
      <h3 class="heading-xxs">Namn och personnummer</h3>
      <!--
      <button
        aria-label="Identifiera om dig som annan person"
        class="body-link-md text-text-link underline halebop-focus mt-10 hover:text-text-link-hover active:bg-surface-action-hover"
        @click="resetIdentificationAndCart()"
      >
        Identifiera om
      </button>
      -->
    </template>
    <template #right>
      <p v-if="checkoutStore.fetchedData.address">
        {{ checkoutStore.fetchedData.address?.FirstName }}
        {{ checkoutStore.fetchedData.address?.LastName }}
      </p>
      <AppLoadingSkeletonTextRow
        v-else-if="checkoutStore.ui.loading.isStep3AddressLoading"
        container-extra-classes="items-start md:items-end"
        text-for-screen-reader="Laddar din adress, vänligen vänta"
        :text-row-width="120"
      />

      <p v-if="checkoutStore.fetchedData.ssnCensored">
        {{ checkoutStore.fetchedData.ssnCensored }}
      </p>
      <AppLoadingSkeletonTextRow
        v-else-if="
          checkoutStore.ui.loading.isStep3AddressLoading ||
          checkoutStore.ui.loading.isStep3SsnCensoredLoading
        "
        container-extra-classes="items-start md:items-end"
        text-for-screen-reader="Laddar din adress, vänligen vänta"
        :text-row-width="150"
      />
    </template>
  </CheckoutAddressInfoItem>

  <CheckoutAddressInfoItem>
    <template #left>
      <h3 class="heading-xxs">Leverans till folkbokföringsadressen</h3>
      <p>Till ett utlämningsställe närmast din folkbokföringsadress</p>
    </template>
    <template v-if="checkoutStore.fetchedData.address" #right>
      <p v-if="checkoutStore.fetchedData.address?.Street">
        {{ checkoutStore.fetchedData.address?.Street }}
      </p>
      <p v-if="checkoutStore.fetchedData.address?.Address1">
        {{ checkoutStore.fetchedData.address?.Address1 }}
      </p>
      <p v-if="checkoutStore.fetchedData.address?.Address2">
        {{ checkoutStore.fetchedData.address?.Address2 }}
      </p>
      <p class="text-start md:text-end">
        {{ checkoutStore.fetchedData.address?.ZipPostalCode }}
        {{ checkoutStore.fetchedData.address?.City }}
      </p>
    </template>

    <template v-else-if="checkoutStore.ui.loading.isStep3AddressLoading" #right>
      <AppLoadingSkeletonTextRow
        :text-row-width="120"
        text-for-screen-reader="Laddar din adress, vänligen vänta"
      />
    </template>
  </CheckoutAddressInfoItem>
</template>

<script lang="ts" setup>
//import { clearAccessTokenCookie } from '~/utils/general/cookieFunctions';
const checkoutStore = useMyCheckoutStore();

// Feature is disabled until we look into making it more clear for the user what it means
//function resetIdentificationAndCart() {
//  clearAccessTokenCookie();
//  checkoutStore.clearCartData();
//}
</script>

<style scoped lang="scss"></style>
